import { createReducer, on } from '@ngrx/store';
import { setChartData } from 'ChartApp/ts/features/fund-chart-page-shared/state/reducers/chart-data/chart-data.actions';
import { FORMAT_DEFAULT } from 'ChartApp/ts/features/fundamental-chart/constants';
import { setFundChartFormat } from './format.actions';
export const format = createReducer(FORMAT_DEFAULT, on(setChartData, (state, { chartData }) => chartData.params.format), on(setFundChartFormat, (state, { format: newFormat }) => newFormat));
